/**
 * Recent pages storage for the command palette (global search).
 * Keeps the last few navigated nav-leaf paths in localStorage so the
 * palette can show a "Недавние" section when the query is empty.
 */

const KEY = 'toss:command-recent';
const MAX = 6;

export function getRecentPaths(): string[] {
  try {
    const raw = localStorage.getItem(KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed.filter((p): p is string => typeof p === 'string') : [];
  } catch {
    return [];
  }
}

export function pushRecentPath(path: string): void {
  try {
    const next = [path, ...getRecentPaths().filter((p) => p !== path)].slice(0, MAX);
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch {
    /* ignore storage errors */
  }
}
